<template>
  <div id="app" class="w3-content">
    <div class="appWrapperw">
      <div class="navbarWrapper">
        <nav-bar/>
      </div>
      <div class="content w3-main w3-margin-bottom">
        <router-view/>
      </div>
    </div>
  </div>
</template>

<script>
import NavBar from "@/components/NavBar.vue";
import { mapActions } from "vuex";
export default {
  name: "App",
  components: { "nav-bar": NavBar },
  data: function() {
    return {
    };
  },
  methods: {
    
  }
};
</script>


<style lang="less">
@import "./assets/w3.less";
</style>
